export default __webpack_public_path__ + "static/media/13.1be3d4e1.jpg";